import React from 'react';
import styled from 'styled-components';

import { Button } from './Button';
import { buttonStyles } from './buttonStyles';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ButtonBase = styled((props: any) => {
  const {
    size: sizeProp,
    boxShadow,
    borderRadius,
    reverse,
    blue,
    green,
    square,
    light,
    ...buttonProps
  } = props;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Button {...buttonProps} />;
}).attrs((props) => ({
  type: props.type || 'button',
}))`
  ${buttonStyles}
`;
